import React from "react";
import { useAppModel } from "../appModel";
import { SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import useGlobalModel from "@/model/globalModel";


export function PageHeader() {
    const {
        searchParam,
        loadData,
        updateSearchParam,
        resetSearchParam
    } = useAppModel();

    const { appDs } = useGlobalModel(({ appDs }) => [appDs]);

    const searchFields = [

        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "分支",
            fieldName: "branch",
            size: "small",
            disabled: false,
            options: appDs
        },
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "应用编码",
            fieldName: "code",
            size: "small",
            disabled: false
        },
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "应用名称",
            fieldName: "name",
            size: "small",
            disabled: false
        },
    ]

    return (
        <YhPageHeader
            title="应用管理"
            searchValues={searchParam}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}